import { render, staticRenderFns } from "./ComputeResource.vue?vue&type=template&id=7bf853b6&"
import script from "./ComputeResource.vue?vue&type=script&lang=js&"
export * from "./ComputeResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports